const Helpers = {};
/**
 * Apply a Constructor function to existing object
 *
 * Example: `this.name` in parent will become `this.name` in the base
 *
 * @param {Object} base The object which will inherit
 * @param {Function} parent Foreign function to be executed on Function
 */
Helpers.inherits = function(base, parent) {
    base = parent.apply(base);
};

/**
 * Run Module() and make its properties available on the base
 *
 * Properties whose name starts with '__' are excluded
 *
 * @param {Object} base The object which will receive properties
 * @param {Function} Module The function whose properties will be harvested
 */
Helpers.extend = function(base, Module) {
    var toHarvest = new Module();
    var classPropNames = Object.getOwnPropertyNames(toHarvest).filter(
        function(propName) {
            return propName.slice(0,2) !== '__';
        });

    classPropNames.forEach(function(classPropName) {
        if(base[classPropName] !== undefined) return; //dont overwrite
        var propertyDescriptor = Object.getOwnPropertyDescriptor(toHarvest, classPropName);
        Object.defineProperty(base, classPropName, propertyDescriptor);
    });
};

/**
 * Run Module() and make its public __properties available to Objects created with Function.new()
 *
 * Exclusively properties whose name starts with '__' are harvested
 * Example: `Module() { this.__index = 1; }` will be available to `(Function.new()).index`
 *
 * @param {Object} base The object that will be extended
 * @param {Function} Module The function whose __properties will be harvested
 */
Helpers.include = function(base, Module) {
    var oldConstructor = base.new;
    var toHarvest = new Module();
    var instancePropNames = Object.getOwnPropertyNames(toHarvest).filter(
        function(propName) {
            return propName.slice(0, 2) === '__';
        });

    //Exposing instanceProperties to instances through `Function.new()`
    base.new = function() {
        var instance = oldConstructor.apply(this, arguments);

        instancePropNames.forEach(function(instancePropName) {
            if(this[instancePropName.slice(2)] !== undefined) return; //dont overwrite
            var propDescriptor = Object.getOwnPropertyDescriptor(toHarvest, instancePropName);
            Object.defineProperty(this, instancePropName.slice(2), propDescriptor);
        },instance);

        return instance;
    };

};

/**
 * @description
 * Shortcut method to 'hide & protect' a property by disabling enumerability and making this configuration immutable
 *
 * @param {Object} object The object to receive a private variable
 * @param {String} name Name of private variable
 * @param {Any} value Value of private variable
 */
Helpers.privateVariable = function(object, name, value) {
    var val;
    Object.defineProperty(object, name, {
        enumerable: false,
        configurable: false,
        get: function() { return val; },
        set: function(newval) { val = newval; }
    });

    if (value !== undefined) object[name] = value;
};

angular.module('BaseClass.Helpers',[]).factory('Helpers', function() {
    return Helpers;
});

export default Helpers;
